export default {
  init() {
    return {
      showAbout: false,
      showPopular: false,
      showMore: false
    };
  },

  /**
   *
   * @param {Object} moduleState
   * @param {String} payload
   * @return {Function} Object.assign()
   */
  updateVideoPath(moduleState, payload) {
    return Object.assign({}, moduleState, {videoPath: payload});
  }
};



// WEBPACK FOOTER //
// ./home/en-US/js/wia-launcher/sdo/mutations.js